import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  Input,
  ViewChild,
  AfterViewInit,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
  ViewEncapsulation
} from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { UserInfo } from 'app/services/api.service';

@Component({
    selector: 'app-select-postal',
    templateUrl: './select-postal.component.html',
    styleUrls: ['./select-postal.component.scss'],
    standalone: true,
    imports: [CommonModule, TranslateModule],
    encapsulation: ViewEncapsulation.None 
})

export class SelectPostalComponent implements AfterViewInit, OnChanges {
    @ViewChild('postalInput') postalInput!: ElementRef;
    @Input() userInfo!: UserInfo;
    @Input() disabled: boolean = false;
    @Input() country: string | null = null;

    @Output() postalSelected = new EventEmitter<{ postalCode: string; city: string; country: string }>();

    postalWidget: any;
    selectedSuggestion: {
        postalCode: string;
        city: string;
        country: string;
    } | null = null;

    ngAfterViewInit() {
        this.initializeWoosmap();        
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['country'] && !changes['country'].firstChange) {
            this.resetWidget();
        }
    }

    private resetWidget() {
        if (this.postalWidget) {
            this.postalWidget = null;
        }
        if (this.postalInput) {
            this.postalInput.nativeElement.value = '';
        }
        this.selectedSuggestion = null;
        this.initializeWoosmap();
    }

    initializeWoosmap() {
        if (
            // @ts-ignore  
            window['woosmap'] && window['woosmap'].localities &&
            this.postalInput
        ) {
            if (!this.postalWidget) {
                const countryCode = this.country || this.userInfo.country;
                // @ts-ignore        
                this.postalWidget = new window['woosmap'].localities.Autocomplete(
                    this.postalInput.nativeElement.id,
                    {
                        minLength: 1,
                        data: 'advanced',
                        types: ['postal_code'],
                        language: 'en',
                        components: {
                            country: countryCode
                        }
                    }
                );

                this.postalWidget.addListener('selected_suggestion', () => {
                    this.onPostalSelected();
                });
            }
        }
    }

    onPostalSelected() {
        const details = this.postalWidget.getSelectedSuggestionDetails();
        let postalCode = '';
        let city = '';
        let country = '';

        for (const comp of details.address_components) {
            if (comp.types.includes('postal_code')) {
                postalCode = comp.long_name;
            }
            if (comp.types.includes('locality')) {
                city = comp.long_name;
            }
            if (comp.types.includes('country')) {
                country = comp.long_name;
            }
        }

        this.selectedSuggestion = {
            postalCode,
            city,
            country
        };

        this.postalSelected.emit(this.selectedSuggestion);
    }
}
